import React from 'react';
import { isMeetingPending } from 'common-data-handling';
import { isMeetingCreatedByUser } from '../../../../../../data/filters/meetings/isMeetingCreatedByUser';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../../../data/hooks/sessionHooks';

function PendingStatus(props) {
    const { className = '', meeting, style = {} } = props,
        selfId = useMyUserId(),
        selfInitiated = isMeetingCreatedByUser(selfId, meeting),
        i18n = useI18n(),
        label = selfInitiated ? i18n['meeting.status.waiting-for-response'] : i18n['meeting.status.awaiting-your-response'];

    if (!isMeetingPending(meeting)) return null;

    return (
        <p className={[className, 'text', 'italic', selfInitiated ? '' : 'bold'].join(' ')} style={style}>
            {label}
        </p>
    );
}

export default PendingStatus;
